export default __webpack_public_path__ + "static/Waymark-4667985c126df836db62b75cc66b1a2b.jpg";